const papaCSVParser = require('papaparse');

const parseDataToCsv = (data) => {
  return papaCSVParser.parse(data, {
    header: true,
    delimiter: ",",
    dynamicTyping: false, // don't make this true - it will eliminate possible entry 0's in cusips
    transformHeader: (header) => {
      return header.trim().toLowerCase(); // otherwise spaces around commas are added in
    }
  });
}

const validateParsedCsvErrors = (csvObj) => {
  return csvObj.length > 0 && csvObj.map((err) => err.message);
}

const validateCsvValuesExist = (csv) => {
  return csv.length === 0 && ['CSV has no values'];
}

const validateHeaders = (csvFirstRow) => {
  const requiredHeaders = ['cusip', 'sell price', 'buy price'];
  const csvObjectHeaders = Object.keys(csvFirstRow);

  const missingHeaders = requiredHeaders.filter((requiredHeader) => {
    return !csvObjectHeaders.includes(requiredHeader)
  });

  const errors = missingHeaders.map((name) => {
    return `Header ${name} is missing and is required.`
  });

  return errors.length > 0 && errors;
}

const validateCusipValues = (csv) => {
  const rowsMissingCusips = csv.filter((current) => {
    return cusipNotExists = current.cusip === '' || current.cusip === null || current.cusip === undefined
  });
  return rowsMissingCusips.map((current) => {
    return `Buy price: ${current['buy price']}, Sell price: ${current['sell price']} row missing cusip`
  });
}

const validatePriceValues = (csv) => {
  const errors = [];

  csv.forEach((current) => {
    const sellPrice = current['sell price'];
    const buyPrice = current['buy price'];

    // Prices are actually numbers
    const sellPriceNotNumber = sellPrice.match(/^[a-z]+$/) || isNaN(sellPrice);
    const buyPriceNotNumber = buyPrice.match(/^[a-z]+$/) || isNaN(buyPrice);

    sellPriceNotNumber && errors.push(`Sell price for cusip ${current.cusip} is not a number: ${sellPrice}.`);
    buyPriceNotNumber && errors.push(`Buy price for cusip ${current.cusip} is not a number: ${buyPrice}.`);

    // Prices are not zero
    const sellPriceBelowZero = sellPrice <= 0;
    const buyPriceBelowZero = buyPrice <= 0;

    sellPriceBelowZero && errors.push(`Sell price for cusip ${current.cusip} is at or below $0.`);
    buyPriceBelowZero && errors.push(`Buy price for cusip ${current.cusip} is at or below $0.`);
  });

  return errors;
}

/**
 * Validates a CSV string to ensure it has required information and format
 * @param {data} - a <textarea> string we expect to conform to CSV standard
 * @returns {(false|Array)} - either false or an Array of Strings which detail any failed validations
 */

module.exports = (data) => {
  const parsedCsvObj = parseDataToCsv(data);

  const parsedErrors = validateParsedCsvErrors(parsedCsvObj.errors);
  if (parsedErrors) return parsedErrors;

  const csv = parsedCsvObj.data;

  const valuesNotExist = validateCsvValuesExist(csv);
  if (valuesNotExist) return valuesNotExist;

  const headersErrors = validateHeaders(csv[0]);
  if (headersErrors) return headersErrors;

  const cusipErrors = validateCusipValues(csv);
  const valueErrors = validatePriceValues(csv);

  return (cusipErrors.length > 0 || valueErrors.length > 0) && cusipErrors.concat(valueErrors);
}
